export default "__VITE_ASSET__9133b364__"